
export type UserStatsResponseBadgesItem = {
  description?: string;
  earnedAt?: string;
  id?: string;
  imageUrl?: string;
  name?: string;
};
